import React from 'react';
import styles from './FunnelCard.module.css';

/**
 * FunnelCard — renders horizontal stepped bars showing funnel conversion.
 *
 * Props:
 *   entry    {object} — registry entry with label, cardType, etc.
 *   cardData {object} — { steps: [{ name, count, conversionRate, dropOff }] }
 *   metricId {string} — metric identifier
 */
const FunnelCard = ({ entry, cardData }) => {
  const steps = cardData?.steps || [];

  return (
    <div className={styles.card}>
      <div className={styles.label}>{entry.label}</div>
      {steps.length === 0 ? (
        <div className={styles.empty}>No funnel data</div>
      ) : (
        steps.map((step, index) => {
          const widthPercent = Math.min(100, Math.max(0, step.conversionRate));
          return (
            <div key={step.name} className={styles.step}>
              <div className={styles.stepHeader}>
                <span className={styles.stepName}>{step.name}</span>
                <span className={styles.stepStats}>{step.conversionRate}%</span>
              </div>
              <div className={styles.barTrack}>
                <div
                  className={styles.barFill}
                  style={{ width: `${widthPercent}%` }}
                >
                  <span className={styles.barCount}>{step.count}</span>
                </div>
              </div>
              {index > 0 && step.dropOff > 0 && (
                <div className={styles.dropoff}>
                  &darr; {step.dropOff} dropped
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default FunnelCard;
